/* The More services (Oct 2026, mock Fix_D change 13). A service shows only in a city
   where at least one business offers it - the list comes from the public company config
   (servicesLive, e.g. { "Vijayawada": ["car-wash"] }, set by the team when a business
   joins). None has one today, so the Services tab and page stay out of the way. */

export const SERVICES = [
  { id: "vehicle-towing-van", icon: "🚛", key: "ms_towing", color: "#2B6AE0" },
  { id: "driving-school", icon: "🎓", key: "ms_school", color: "#14A44D" },
  { id: "monthly-lease", icon: "📋", key: "ms_lease", color: "#3D7EFF" },
  { id: "tours-packages", icon: "🏝️", key: "ms_tours", color: "#3D7EFF" },
  { id: "car-wash", icon: "🫧", key: "ms_wash", color: "#0891B2" },
  { id: "mechanic", icon: "🔧", key: "ms_mechanic", color: "#7C3AED" },
  { id: "accessories", icon: "🎁", key: "ms_accessories", color: "#BE185D" },
];

const CITY_KEY = "sramika_selected_city";
const currentCity = () => { try { return localStorage.getItem(CITY_KEY) || ""; } catch { return ""; } };

/** The services a city has a business for (the visitor's city when none is given). */
export function liveServices(cfg, city = currentCity()) {
  const ids = cfg?.servicesLive?.[city];
  return Array.isArray(ids) ? SERVICES.filter((s) => ids.includes(s.id)) : [];
}
